import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule as ACommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { TYTCommonModule } from '@tytapp/common';
import { UserModule } from '@tytapp/user';

import { Playback } from './playback';
import { PlayerComponent } from './player/player.component';
import { PlayerVolumeButtonComponent } from './player-volume-button/player-volume-button.component';
import { PlayerSeekBarComponent } from './player-seek-bar/player-seek-bar.component';
import { PlayerService } from './player/player.service';
import { ShowsComponent } from './shows/shows.component';
import { CommonUiModule } from 'common-ui';
import { MediaServiceRegistry } from './media-service-registry';
import { RemoteAudioPlayerComponent } from './remote-audio-player/remote-audio-player.component';
import { ProductionViewComponent } from './production-view/production-view.component';
import { ShowProductionViewComponent } from './show-production-view/show-production-view.component';
import { PlaybackStatusBarComponent } from './playback-status-bar/playback-status-bar.component';
import { GoogleCastService } from './google-cast.service';
import { CastButtonComponent } from './cast-button/cast-button.component';
import { AirPlayService } from './airplay.service';
import { AirplayButtonComponent } from './airplay-button/airplay-button.component';
import { PlayerBannerComponent } from './player-banner/player-banner.component';

const COMPONENTS = [
    PlayerComponent,
    PlayerSeekBarComponent,
    PlayerVolumeButtonComponent,
    ShowsComponent,
    ProductionViewComponent,
    ShowProductionViewComponent,
    RemoteAudioPlayerComponent,
    PlaybackStatusBarComponent,
    CastButtonComponent,
    AirplayButtonComponent,
    PlayerBannerComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    HttpClientModule,
    FormsModule,
    ACommonModule,
    RouterModule,
    UserModule,
    TYTCommonModule,
    CommonUiModule
  ],
  exports: COMPONENTS
})
export class MediaPlaybackModule { 
  static forRoot(): ModuleWithProviders<MediaPlaybackModule> {
    return {
        ngModule: MediaPlaybackModule,
        providers: [
            MediaServiceRegistry,
            Playback,
            PlayerService,
            GoogleCastService,
            AirPlayService
        ]
    };
}
}
